package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.CenterInterestState
import io.horion.cv.styles.ActivityFullWidthFieldStyle
import org.jetbrains.compose.web.css.px

@Composable
fun CenterInterestForm(
    index: Int,
    state: CenterInterestState,
    cvViewModel: CvViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(25.px),
    ) {
        TextFormField(
            label = "Centre d'intérêt",
            value = state.center_interest,
            onValueChange = {
                state.center_interest = it
                cvViewModel.updateHobby(index, it)
            },
            modifier = ActivityFullWidthFieldStyle.toModifier()
        )

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }

}